module.exports = __webpack_public_path__ + "static/media/logo512.273b96f1.png";